export const fetchAirlines = async () => {
  try {
    const response = await fetch(
      "https://raw.githubusercontent.com/jpatokal/openflights/master/data/airlines.dat"
    )

    if (!response.ok) throw new Error("Ошибка загрузки данных")

    const csv = await response.text()

    const lines = csv.split("\n").filter((line) => line.trim())

    const airlines = lines
      .map((line) => {
        const [id, name, alias, iata, icao, callsign, country, active] = line.split(",")

        return {
          iata: iata?.replace(/"/g, "").trim(),
          icao: icao?.replace(/"/g, "").trim(),
          name: name?.replace(/"/g, "").trim(),
          country: country?.replace(/"/g, "").trim(),
        }
      })
      .filter((airline) => {
        if (
          !airline.iata ||
          airline.iata === "\\N" ||
          airline.iata.length !== 2 ||
          airline.iata === ".." ||
          airline.iata === "??" ||
          airline.iata === "--" ||
          !/^[A-Z0-9]{2}$/.test(airline.iata)
        ) {
          return false
        }

        const russianIataCodes = ["SU", "S7", "U6", "FV", "DP", "N4", "R3", "NN", "WZ", "5N"]
        if (russianIataCodes.includes(airline.iata)) return false

        const cisAndEuropeCountries = [
          "Ukraine",
          "Belarus",
          "Kazakhstan",
          "Uzbekistan",
          "Azerbaijan",
          "Georgia",
          "Armenia",
          "Kyrgyzstan",
          "Tajikistan",
          "Turkmenistan",
          "Moldova",
          "Germany",
          "France",
          "United Kingdom",
          "Italy",
          "Spain",
          "Netherlands",
          "Poland",
          "Belgium",
          "Austria",
          "Switzerland",
          "Sweden",
          "Norway",
          "Denmark",
          "Finland",
          "Ireland",
          "Portugal",
          "Czech Republic",
          "Greece",
          "Hungary",
          "Romania",
          "Bulgaria",
          "Croatia",
          "Slovakia",
          "Lithuania",
          "Latvia",
          "Estonia",
          "Slovenia",
          "Luxembourg",
          "Malta",
          "Cyprus",
          "Iceland",
          "Turkey",
          "Serbia",
          "Albania",
          "Montenegro",
          "North Macedonia",
          "Bosnia and Herzegovina",
          "Kosovo",
        ]

        return cisAndEuropeCountries.includes(airline.country)
      })

    const uniqueAirlines = Array.from(
      new Map(airlines.map((airline) => [airline.iata, airline])).values()
    )

    return uniqueAirlines
  } catch (error) {
    console.error("Ошибка загрузки авиакомпаний:", error)
    return []
  }
}

let airlinesCache = null

const parseCSVLine = (line) => {
  const values = line.match(/(".*?"|\\N|[^,]+)/g).map((v) => {
    if (v === "\\N") return null
    if (v === '""') return ""
    if (v.startsWith('"') && v.endsWith('"')) return v.slice(1, -1)
    if (!isNaN(v)) return Number(v)
    return v
  })

  return {
    id: values[0],
    name: values[1],
    alias: values[2],
    iata: values[3],
    icao: values[4],
    callsign: values[5],
    country: values[6],
    active: values[7] === "Y",
  }
}

// export const fetchAirlinesByIata = async (iataCodes = []) => {
//   try {
//     if (!Array.isArray(iataCodes) || iataCodes.length === 0) {
//       return []
//     }

//     const normalizedCodes = iataCodes
//       .map((code) => code?.toUpperCase().trim())
//       .filter((code) => /^[A-Z0-9]{2}$/.test(code))

//     if (normalizedCodes.length === 0) return []

//     if (!airlinesCache) {
//       const response = await fetch(
//         "https://raw.githubusercontent.com/jpatokal/openflights/master/data/airlines.dat"
//       )

//       if (!response.ok) {
//         throw new Error("Ошибка загрузки данных")
//       }

//       const csv = await response.text()
//       airlinesCache = csv.split("\n").filter((line) => line.trim())
//     }

//     const airlines = airlinesCache.reduce((acc, line) => {
//       const { iata, icao, name, country, active } = parseCSVLine(line)

//       const cleanIata = iata?.trim()

//       if (cleanIata && cleanIata !== "\\N" && normalizedCodes.includes(cleanIata)) {
//         acc.push({
//           iata: cleanIata,
//           icao: icao?.trim(),
//           name: name?.trim(),
//           country: country?.trim(),
//           active,
//         })
//       }

//       return acc
//     }, [])

//     return Array.from(new Map(airlines.map((a) => [a.iata, a])).values())
//   } catch (error) {
//     console.error("Ошибка загрузки авиакомпаний:", error)
//     return []
//   }
// }

// export const fetchAirlinesByIata = async (iataCodes = []) => {
//   try {
//     if (!Array.isArray(iataCodes) || iataCodes.length === 0) {
//       return []
//     }

//     const normalizedCodes = iataCodes
//       .map((code) => code?.toUpperCase().trim())
//       .filter((code) => /^[A-Z0-9]{2}$/.test(code))

//     if (normalizedCodes.length === 0) return []

//     if (!airlinesCache) {
//       const response = await fetch(
//         "https://raw.githubusercontent.com/NemoTravel/nemo.travel.geodata/master/airlines.json"
//       )

//       if (!response.ok) throw new Error("Ошибка загрузки данных")

//       airlinesCache = await response.json()
//     }

//     const airlines = normalizedCodes.reduce((acc, iata) => {
//       const info = airlinesCache[iata]

//       if (info) {
//         acc.push({
//           iata,
//           name: info.name?.en ?? null,
//           country: info.country ?? null,
//           logo: info.logo?.file ?? null,
//         })
//       }

//       return acc
//     }, [])

//     return airlines
//   } catch (error) {
//     console.error("Ошибка загрузки авиакомпаний:", error)
//     return []
//   }
// }

export const fetchAirlinesByIata = async (iataCodes = []) => {
  try {
    if (!Array.isArray(iataCodes) || iataCodes.length === 0) {
      return []
    }

    const normalizedCodes = iataCodes
      .map((code) => code?.toUpperCase().trim())
      .filter((code) => /^[A-Z0-9]{2}$/.test(code))

    if (normalizedCodes.length === 0) return []

    if (!airlinesCache) {
      const response = await fetch("/data/airlines.json")

      if (!response.ok) {
        throw new Error("Ошибка загрузки airlines.json")
      }

      airlinesCache = await response.json()
    }

    const airlines = normalizedCodes.reduce((acc, iata) => {
      const info = airlinesCache[iata]

      if (info) {
        acc.push({
          iata,
          name: info.name?.en ?? null,
          country: info.country ?? null,
          logo: info.logo?.file ?? null,
        })
      }

      return acc
    }, [])

    return airlines
  } catch (error) {
    console.error("Ошибка загрузки авиакомпаний:", error)
    return []
  }
}
